import { render } from "./TrackPicker.vue?vue&type=template&id=04d840bc&ts=true"
import script from "./TrackPicker.vue?vue&type=script&lang=ts"
export * from "./TrackPicker.vue?vue&type=script&lang=ts"

import "./TrackPicker.vue?vue&type=style&index=0&id=04d840bc&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__